import React, { useState, useEffect, useMemo, memo } from "react";
import DataTable from "react-data-table-component";
import apiCaller from "../../api/ApiCaller";

const PaginationDataTable = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(props.pageSize || 10);
    const [currentPage, setCurrentPage] = useState(props.currentPage || 1);
    const customStyles = {
        rows: {
            style: {
                overflow: "visible !important",
                width: "auto",
            },
        },
        headCells: {
            style: {
                minWidth: "153px !important",
            },
        },
        cells: {
            style: {
                overflow: "visible !important",
                // minWidth: "140px"
                minWidth: "153px !important",
                // maxWidth: "200px !important"
            },
        },
    };

    const [columns, setColumns] = useState(
        useMemo(() => [], [])
    );


    useEffect(() => {
        if(props?.columns?.length > 0){
            setColumns(props.columns);
            fetchData(currentPage);
        }
    }, [props]);

    // Sync with external pagination state - more responsive
    useEffect(() => {
        if (props.currentPage) {
            setCurrentPage(props.currentPage);
            fetchData(props.currentPage);
        }
    }, [props.currentPage]);

    useEffect(() => {
        if (props.pageSize) {
            setPerPage(props.pageSize);
            fetchData(1, props.pageSize);
        }
    }, [props.pageSize]);

    // Force refresh when drawCount changes
    useEffect(() => {
        if (props.drawCount > 0) {
            fetchData(currentPage, perPage);
        }
    }, [props.drawCount]);

    const callPostApi = (url, data, headerMap, successCallBack, failedCallBack) => {
        apiCaller.callPostApi(url, data, headerMap, successCallBack, failedCallBack);
    }

    const fetchData = async (page, size = perPage) => {
        setLoading(true);
        var jsonRequest = {
            "page": page - 1,
            "size": size,
            searchFilters: props.specificFilters ? props.specificFilters : props.filters ? props.filters.searchFilters : [],
            sortRules: props.filters ? props.filters.sortRules : [],
        };
        
        callPostApi(props.paginationUrl, jsonRequest, {}, (response) => {
            setData(response?.data || []);
            setTotalRows(response.totalItems);
            setLoading(false);
        }, (error) => {
            setLoading(false);
            console.error(error);
        })
    };

    const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
        // Call external pagination change handler if provided
        if (props.onPaginationChange) {
            props.onPaginationChange(page, perPage);
        }
    };

    const handleChange = ({ selectedRows }) => {
        // You can set state or dispatch with something like Redux so we can use the retrieved data
        props.setDeleteAbleRowsData(selectedRows)
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(1, newPerPage);
        setPerPage(newPerPage);
        // Call external pagination change handler if provided
        if (props.onPaginationChange) {
            props.onPaginationChange(1, newPerPage);
        }
    };
    return (
        <>
            {props.selectedAble ?

                <DataTable
                    className="pagination-data-table"
                    title=""
                    columns={columns}
                    data={data}
                    pagination={props.paginationStatus}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    customStyles={customStyles}
                    selectableRows
                    onSelectedRowsChange={handleChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    persistTableHead
                /> :
                <DataTable
                    className="pagination-data-table"
                    title=""
                    columns={columns}
                    data={data}
                    pagination={props.paginationStatus}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    customStyles={customStyles}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    persistTableHead
                />
            }
        </>

    );
}

export default memo(PaginationDataTable);